define('tinymce-plugins/wa5_math/plugin',['tinymce/AddOnManager', "tinymce/html/Serializer", "tinymce/html/Schema",
		"tinymce/html/DomParser", "tinymce/html/Node"
], function(AddOnManager, Serializer, Schema, DomParser, Node) {
	var latexUrl = '/rendering/formula?formula=';
	function getLatexURL(latex) {
		latex = $.trim(latex);
		return latexUrl + encodeURIComponent(latex);
	}

	AddOnManager.PluginManager.add('wa5_math', function(editor, url) {
		var mathEditor = {
			initialized: false,
			group: null,
			overlay: null,
			wrap: null,
			mathquill: null,
			imgElement: null,
			
			init: function() {
				var self = this;
				
				if (!this.initialized) {
					this.group = $('<div>').attr('id', 'math-editor').appendTo($('body'));
					this.overlay = $('<div>').attr('id', 'math-editor-overlay').appendTo(this.group);
					this._setupOverlay();
					this.wrap = $('<div>').attr('id', 'math-editor-wrap').appendTo(this.group);
										
					this.mathquill = $('<div>').text('insert here').appendTo(this.wrap);
					this.mathquill.mathquill('editable');
					this.overlay.click(function() {
						self.close();
					});

					this.wrap.on('keydown', function(e) {
						switch (e.keyCode) {
						case 13: // return
						case 27: // esc
							self.close();
							break;
						default:
							self.storeFormulaFromMathquill();
							self.scheduleApplyToImageElement();
							self.applyWrapDimensionsToImageElement();
						}
					});
					this.initialized = true;
				}
			},
			
			insert: function(latex) {
				if (!this.open)
					return;

				this.mathquill.mathquill('write', latex)
				this.mathquill.find('textarea').focus();
				this.apply(); // save changes
			},
			
			show: function(imgElement, definition) {
				var self = this;
				this.init();
				this.imgElement = imgElement;
				this.definition = definition;
				$(imgElement).addClass('math-editor-open');
				editor.nodeChanged(); // imgElement has changed its semantics
				
				// image loading takes a while, so adjust position when new image sizes are known
				$(imgElement).on('load', function() { self._updatePosition();});
				
				this.group.show();
				this._updatePosition();
				this.mathquill.mathquill('revert').text(definition.latex).mathquill('editable');
				this.mathquill.find('textarea').focus();
				this.open = true;
			},
			
			_updatePosition: function() {
				var offset1 = $(this.imgElement).offset();
				var offset2 = $(editor.contentAreaContainer).offset();
				var left = offset1.left + offset2.left;
				
				// The image may be 1x1 pixel in size for empty formulas
				var imageTop = offset1.top + offset2.top;
				var bottom = imageTop + $(this.imgElement).height();
				var wrapTop = bottom - this.wrap.height();

				this.wrap.css({left: left, top: wrapTop}).show();
			},

			storeFormulaFromMathquill: function() {
				this.definition.latex = this.mathquill.mathquill('latex');
			},
			
			apply: function() {
				if (!this.definition)
					return;

				this.storeFormulaFromMathquill();
				var attributes = {
					'data-definition': JSON.stringify(this.definition),
					'src': getLatexURL(this.definition.latex),
					'alt': this.definition.latex,
					'width': null,
					'height': null
				};
				editor.dom.setAttribs(this.imgElement, attributes);
				this._updatePosition(); // img element may have wrapped
			},

			/**
			 * Schedules a call of apply() once not called for a short amount of time
			 */
			scheduleApplyToImageElement: function() {
				if (this.applyTimeout) {
					clearTimeout(this.applyTimeout);
				}
				this.applyTimeout = setTimeout(this.apply.bind(this), 10000);
			},

			applyWrapDimensionsToImageElement: function() {
				editor.dom.setAttribs(this.imgElement, {
					width: this.wrap.width(),
					height: this.wrap.height()
				});
				this._updatePosition();
			},
			
			close: function() {
				if (this.initialized) {
					$(this.imgElement).removeClass('math-editor-open');
					editor.nodeChanged(); // imgElement has changed its semantics
					this.definition.latex = $.trim(this.definition.latex);
					if (!this.definition.latex)
						$(this.imgElement).remove();
					else
						this.apply();
					this.group.hide();
					this.open = false;
				}
			},
			
			_setupOverlay: function() {
				var elem = $(editor.contentAreaContainer);
				var offset = elem.offset();
				this.overlay.css({
					left: offset.left,
					top: offset.top,
					width: elem.css('width'),
					height: elem.css('height')});
			}
		}
		
		function showEditor() {
			var selectedElement = editor.selection.getNode();
			var dom = editor.dom;
			var imgElement = null;
			var definition = {type: 'math', latex: ''};
			
			if (selectedElement.nodeName == 'IMG' && !selectedElement.getAttribute('data-mce-object')) {
				var def = JSON.parse(dom.getAttrib(selectedElement, 'data-definition'));
				if (definition.type == 'math') {
					imgElement = selectedElement;
					definition = def;
				}
			}
			
			var attributes = {
				'data-definition': JSON.stringify(definition),
				'data-mce-resize': 'false',
				'class': 'math',
				'src': getLatexURL(definition.latex)
			};
			
			if (imgElement) {
				dom.setAttribs(imgElement, attributes);
			} else {
				attributes.id = '__mcenew';
				editor.insertContent(dom.createHTML('img', attributes));
				imgElement = dom.get('__mcenew');
				dom.setAttrib(imgElement, 'id', null);
				editor.selection.select(imgElement);
			}
			
			mathEditor.show(imgElement, definition);
		}
		
		// Open editor on double click
		editor.on('Init', function() {
			$(editor.contentDocument.body).on('dblclick', 'img.math', function() {
				showEditor();
			});
		});
	
		editor.addButton('wa5_math', {
			image: editor.baseURI.directory + '/plugins/wa5_math/icons/equation.gif',
			tooltip: 'Formel',
			cmd: 'wa5_math',
			stateSelector: 'img.math:not([data-mce-object])'
		});
		
		editor.addCommand('wa5_math', showEditor);
		
		editor.addCommand('wa5_math_insert', function(ui, value) {
			mathEditor.insert(value);
		});
	
		editor.addMenuItem('wa5_image', {
			image: url + '/icons/equation.gif',
			text: 'Formel',
			onclick: showEditor,
			context: 'insert',
			prependToContext: true
		});
				
		// convert <wa5-math> elements to <img> elements
		editor.on('BeforeSetContent', function(e) {
			// TODO: duplicate code from wa5_image plugin
			// Need to tell the parser that <wa5-image> is shorthanded
			var schema = Object.create(editor.schema)
			schema.getShortEndedElements = function() {
				var map = editor.schema.getShortEndedElements();
				map['wa5-image'] = {};
				map['wa5-math'] = {};
				return map;
			}
			var parser = new DomParser({validate: false}, schema);
			var tree = parser.parse(e.content, {isRootContent: true});

			if (tree)
				walk(tree);

			// clone the settings to disable validation
			var settings = $.extend(true, {}, editor.settings);
			settings.verify_html = false;
			var schema = new Schema(settings);
			var serializer = new Serializer({validate: false}, schema);
			e.content = serializer.serialize(tree);

			function walk(node) {
				if (node.name == 'wa5-math') {
					var definition = {type: 'math', latex: null};
					var styleAttr = null;
					for (var i = 0; i < node.attributes.length; i++) {
						if (node.attributes[i].name == 'style')
							styleAttr = node.attributes[i];
						if (node.attributes[i].name in definition)
							definition[node.attributes[i].name] = node.attributes[i].value;
					}
					
					node.name = 'img';
					node.attributes = [
						{name: 'src', value: getLatexURL(definition.latex)},
						{name: 'alt', value: definition.latex},
						{name: 'data-definition', value: JSON.stringify(definition)},
						{name: 'class', value: 'math'}];
					if (styleAttr)
						node.attributes.push(styleAttr);
					node.firstChild = null;
					node.shortEnded = true;
				}
				
				if ((node = node.firstChild)) {
					do {
						walk(node);
					} while ((node = node.next));
				}
			}
		});
		
		editor.on('BeforeGetContent', function(e) {
			// save changes in open editor
			mathEditor.apply();
		});

		// convert <img> elements to <wa5-math> elements
		editor.on('SaveContent', function(e) {
			var parser = new DomParser({validate: false}, schema);
			var tree = parser.parse(e.content, {isRootContent: true});
			
			if (tree)
				walk(tree);
			
			// clone the settings
			var settings = $.extend(true, {}, editor.settings);
			settings.verify_html = false;
			var schema = new Schema(settings);
			e.content = new Serializer({validate: false}, schema).serialize(tree);
			
			function walk(node) {
				if (node.name == 'img') {
					var definition = null;
					var styleAttr = null;
					for (var i = 0; i < node.attributes.length; i++) {
						if (node.attributes[i].name == 'data-definition') {
							definition = JSON.parse(node.attributes[i].value);
							break;
						}
						if (node.attributes[i].name == 'style')
							styleAttr = node.attributes[i];
					}
					if (definition && definition.type == 'math') {
						node.name = 'wa5-math';
						node.attributes = [ { name: 'latex', value: definition.latex } ];
						if (styleAttr)
							node.attributes.push(styleAttr);
						node.shortEnded = true;
					}
				}
				
				if ((node = node.firstChild)) {
					do {
						walk(node);
					} while ((node = node.next));
				}
			}
		});
	});
});

